<template>
  <custom-dialog width="450px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" label-width="auto" :rules="rules">
        <el-form-item :label="$t('dms_device_rename_dialog.she_bei_ming_cheng')">
          <el-input v-model="form.deviceName"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        deviceName: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        deviceName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$setFormatData(this.form, this.model.data);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.portalDeviceUpdateDeviceName, {
          deviceId: this.model.data.deviceId,
          deviceName: this.form.deviceName,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.visible = false;
          this.$emit('success', this.form);
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
